import { createAction, props } from '@ngrx/store';
import { DictionaryPage } from '../../study-slide-outs/sections/company-drill-down/models/dictionary-page.model';

export const initItemsPerPage = createAction('[Internet Review Matrix Component] Init Items Per Page');

export const itemsPerPageInitiated = createAction(
  '[Internet Review Effects] Items Per Page Initiated',
  props<{ itemsPerPage: number; fetchedFromSessionStore: boolean }>()
);

export const updateItemsPerPage = createAction('[Internet Review Matrix Component] Update Items Per Page', props<{ itemsPerPage: number }>());

export const updateItemsPerPageOptionsUserModification = createAction(
  '[Internet Review Effects] Update Items Per Page Options User Modification',
  props<{ isUpdatedByUser: boolean }>()
);

export const sendExternalDataForDrillDown = createAction(
  '[Internet Review Details Component] Send External Data For Drill Down',
  props<{ idsByPage: DictionaryPage; count: number; rows: number }>()
);

export const sendNavigationDataForDrillDown = createAction(
  '[Internet Review Details Component] Send Navigation Data For Drill Down',
  props<{ page: number; index: number }>()
);

export const sendSelectedComparableIdForDrillDown = createAction(
  '[Internet Review Details Component] Send Selected Comparable Id For Drill Down',
  props<{ id: number }>()
);

export const pageDataLoaded = createAction('[Internet Review Matrix Component] Page Data Loaded', props<{ comparables: any[] }>());

export const comparableDataLoaded = createAction('[Internet Review Details Component] Comparable Data Loaded', props<{ comparables: any[] }>());
